(() => {
  const SECTION_SELECTOR = "[data-shoe-size-guide]";

  const activateTab = (section, tabButton) => {
    if (!section || !tabButton) return;

    const buttons = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

    buttons.forEach((button) => {
      const isActive = button === tabButton;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
      button.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    panels.forEach((panel) => {
      const isTargetPanel =
        panel.id === tabButton.getAttribute("aria-controls");
      panel.hidden = !isTargetPanel;
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.tabsReady === "true") return;

    section.addEventListener("click", (event) => {
      const tabButton = event.target.closest('[role="tab"]');
      if (!tabButton || !section.contains(tabButton)) return;
      activateTab(section, tabButton);
    });

    section.addEventListener("keydown", (event) => {
      const currentTab = event.target.closest('[role="tab"]');
      if (!currentTab || !section.contains(currentTab)) return;

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const currentIndex = tabs.indexOf(currentTab);
      if (currentIndex === -1) return;

      let nextIndex = null;

      if (event.key === "ArrowRight") {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === "ArrowLeft") {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;
      event.preventDefault();
      tabs[nextIndex].focus();
      activateTab(section, tabs[nextIndex]);
    });

    section.dataset.tabsReady = "true";
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) =>
    initAll(event.target),
  );
})();
